import { render, staticRenderFns } from "./analysis-page.vue?vue&type=template&id=b1a51dde&scoped=true&"
import script from "./analysis-page.vue?vue&type=script&setup=true&lang=ts&"
export * from "./analysis-page.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./analysis-page.vue?vue&type=style&index=0&id=b1a51dde&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1a51dde",
  null
  
)

/* custom blocks */
import block0 from "./analysis-page.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports